import { ColorModeContext, useMode } from "./theme";
import { CssBaseline, ThemeProvider, Box } from "@mui/material";
import { Routes, Route, Navigate } from "react-router-dom"; // Importar Navigate para redirecciones
import Home from "./pages/home";
import Topbar from "./pages/global/TopBar";
import Vocacional from "./pages/vocacional";
import Test from "./pages/vocacional/Test";
import Footer from "./pages/global/Footer";
import { AppProvider } from "./pages/vocacional/AppContext"; // Importa tu AppProvider
import ProtectedRoute from "./components/ProtectedRoute"; // Importar el componente ProtectedRoute
import FloatingWhatsAppButton from "./pages/global/FloatingWhatsAppButton";

function App() {
  const [theme, colorMode] = useMode();

  return (
    <AppProvider> {/* Aquí envolvemos todo con AppProvider */}
      <ColorModeContext.Provider value={colorMode}>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <Box display="flex" flexDirection="column" minHeight="100vh">
            <Topbar />
            <Box flexGrow={1}>
              <Routes>
                {/* Página inicial */}
                <Route path="/" element={<Vocacional />} />
                {/* Página del formulario vocacional */}
                <Route path="/voc" element={<Vocacional />} />
                {/* Ruta protegida para el test vocacional */}
                <Route
                  path="/testVocacional"
                  element={
                    <ProtectedRoute>
                      <Test />
                    </ProtectedRoute>
                  }
                />
                {/* Redirección para rutas no encontradas */}
                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
            </Box>
            <Footer />
            <FloatingWhatsAppButton />
          </Box>
        </ThemeProvider>
      </ColorModeContext.Provider>
    </AppProvider>
  );
}

export default App;